import React, { useEffect, useState } from "react"

import { RefinementListProvided } from "react-instantsearch-core"
import { connectRefinementList } from "react-instantsearch-dom"
import { useIntl } from "react-intl"

import glutenFreeIcon from "./assets/gluten-free.svg"
import healthyIcon from "./assets/healthy.svg"
import lactoseFreeIcon from "./assets/lactose-free.svg"
import veganIcon from "./assets/vegan.svg"
import vegetarianIcon from "./assets/vegetarian.svg"
import ColorableSVG from "~/components/ColorableSVG/ColorableSVG"
import { Body } from "~/components/ui"
import useAlgoliaFacets, { mergeItems } from "~/hooks/useAlgoliaFacets"
import { sortRefinementListFacetsByLabel } from "~/utils/algoliaUtils"

import css from "./CustomRefinmentListDiet.module.scss"

type LabelType = {
  [key: string]: { text: string; icon: string }
}

const RefinementList = ({ items, refine }: RefinementListProvided) => {
  const intl = useIntl()

  const { initialFacets } = useAlgoliaFacets()
  const suitable_for_diets = initialFacets["suitable_for_diets.slug"]

  const labels: LabelType = {
    vegetarian: {
      text: intl.formatMessage({
        id: "category/text:diet-label-vegetarian",
      }),
      icon: vegetarianIcon,
    },
    vegan: {
      text: intl.formatMessage({
        id: "category/text:diet-label-vegan",
      }),
      icon: veganIcon,
    },
    "gluten-free": {
      text: intl.formatMessage({
        id: "category/text:diet-label-gluten-free",
      }),
      icon: glutenFreeIcon,
    },
    "lactose-free": {
      text: intl.formatMessage({
        id: "category/text:diet-label-lactose-free",
      }),
      icon: lactoseFreeIcon,
    },
    healthy: {
      text: intl.formatMessage({
        id: "category/text:diet-label-healthy",
      }),
      icon: healthyIcon,
    },
  }

  const [displayedItems, setDisplayedItems] = useState(
    mergeItems({
      activeItems: items ?? [],
      inactiveItems: suitable_for_diets ?? [],
    })
  )

  useEffect(() => {
    setDisplayedItems(
      mergeItems({
        activeItems: items,
        inactiveItems: suitable_for_diets ?? [],
      })
    )
  }, [items, suitable_for_diets])

  const refineDiet = (
    e: React.MouseEvent,
    item: { value: string[]; label: string }
  ) => {
    e.preventDefault()
    refine(item.value)
  }

  return (
    <>
      {displayedItems.sort(sortRefinementListFacetsByLabel).map(item => {
        return (
          <div className={css.filterItem} key={item.label + item.isRefined}>
            <ColorableSVG
              href={labels[item.label].icon}
              width={30}
              height={30}
              onClick={
                item.count === 0 ? undefined : event => refineDiet(event, item)
              }
              mainColor={
                item.count === 0
                  ? "var(--gray4-color)"
                  : item.isRefined
                  ? "var(--original-color)"
                  : "black"
              }
            />
            <Body
              variant="body2"
              semiBold
              color={
                item.count === 0
                  ? "var(--gray4-color)"
                  : item.isRefined
                  ? "var(--original-color)"
                  : "black"
              }
              onClick={
                item.count === 0 ? undefined : event => refineDiet(event, item)
              }
            >
              {labels[item.label].text} ({item.count})
            </Body>
          </div>
        )
      })}
    </>
  )
}

const CustomRefinmentListDiet =
  connectRefinementList<RefinementListProvided>(RefinementList)

export default CustomRefinmentListDiet
